import { Builder } from '@builder.io/react';

import SectionsQualityAssurance from './index';

Builder.registerComponent(SectionsQualityAssurance, {
  name: 'SectionsQualityAssurance',
  inputs: [
    {
      name: 'bg',
      type: 'string',
      defaultValue: 'bg-transparent',
      enum: ['bg-transparent', 'bg-gray-950', 'bg-gray-900', 'bg-gray-100', 'bg-gray-800']
    },
    {
      name: 'overtitle',
      type: 'string'
    },
    {
      name: 'title',
      type: 'string'
    },
    {
      name: 'subtitle',
      type: 'string'
    },
    {
      name: 'texts',
      type: 'list',
      subFields: [{ name: 'text', type: 'longText' }]
    },
    {
      name: 'cta',
      type: 'boolean'
    }
  ]
});
